
import Swiper from 'swiper/bundle';

//kvの無限スライダー
var getTranslate;
var slideWidth;

var mySwiper = new Swiper('.p-homeKv__slider', {
  speed: 4000,
  slidesPerView: 'auto',
  loop: true,
	spaceBetween: 15,
	loopAdditionalSlides: 1,
  freeMode: true,
  freeModeMomentum: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  on: {
    touchEnd: () => {
        getTranslate = mySwiper.getTranslate(); // スライドの現在位置を取得
        slideWidth = document.querySelector('.swiper-slide-active').offsetWidth; //スライドの横幅を取得
        mySwiper.setTranslate(getTranslate - slideWidth); // translateを更新
        mySwiper.setTransition(3000); //transitonを更新
    },
  }
})

//他サービスとの比較エリア、sp時にスワイプした時の挙動
$(function(){
	$(document).on('touchend','.p-homeStrength__tableWrap',function(){
		$('.p-homeStrength__swipe').addClass('is-hide')
	});
});


// 導入事例エリア(slick)
$(function(){
	function sliderSetting(){
		var width = $(window).width();
		if(width <= 768){
			$('.p-homeExample__slickSlider').not('.slick-initialized').slick({
			// arrows: true, // 前・次のボタンを表示する
			// dots: true, // ドットナビゲーションを表示する
			// appendDots: $('.dots-2'), // ドットナビゲーションの生成位置を変更
			speed: 1000, // スライドさせるスピード（ミリ秒）
			slidesToShow: 1, // 表示させるスライド数
			centerMode: true, // slidesToShowが奇数のとき、現在のスライドを中央に表示する
			// centerPadding: "25px",
			variableWidth: true, // スライド幅の自動計算を無効化
			});
		} else {
				$('.p-homeExample__slickSlider.slick-initialized').slick('unslick');
		}
	}
	sliderSetting();
	$(window).resize(function(){
	    sliderSetting();
	});
});

